import { render, staticRenderFns } from "./ModelesEditor.vue?vue&type=template&id=5cd3aacc"
import script from "./ModelesEditor.vue?vue&type=script&lang=js"
export * from "./ModelesEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports